import React from 'react';
import styled, { Colors, Fonts, FontType } from '../../../theme';

const StyledButton = styled('button')<IProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  color: ${(props) => (props.textColor ? props.textColor : Colors.white)};
  background-color: ${(props) => props.color};
  font-family: ${(props) => (props.font ? props.font : Fonts.interSB)};
  font-size: ${(props) => (props.size === 'small' ? '0.875rem' : '1.5625rem')};
  line-height: ${(props) => (props.size === 'small' ? '0.875rem' : '2.5rem')};
  text-decoration: none;
  border: none;
  border-radius: 0.5rem;
  padding: 1.5rem 2rem;
  transition: 0.4s;
  cursor: pointer;
  max-height: 88px;
  height: 6rem;

  &:hover {
    filter: brightness(108%);
  }

  &:disabled {
    background: ${Colors.lightGray};
  }

  @media (max-width: 830px) {
    max-height: 70.375px;
  }
`;

export interface IProps {
  id?: string;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  dataLoading?: boolean;
  onClick?: () => any;
  size?: 'large' | 'small';
  font?: FontType;
  color?: Colors;
  textColor?: Colors;
  className?: string;
}

const Button: React.FC<IProps> = (props) => {
  const { disabled, dataLoading, children, className = '' } = props;
  return (
    <StyledButton disabled={disabled || dataLoading} {...props} className={className}>
      {children}
    </StyledButton>
  );
};

export default Button;
